'use client';

import { useEffect } from 'react';
import { isCapacitorNative } from '@/lib/capacitor-runtime';
import { configureNativeStatusBar, scheduleCapacitorStatusBarSync } from '@/lib/native-permissions';
import { syncCapacitorStatusBarWithDocument } from '@/lib/native-status-bar-colors';

/** Keeps Android/iOS status bar in sync with document theme on all routes (including /login). */
export function NativeStatusBarSync() {
  useEffect(() => {
    if (!isCapacitorNative()) return;

    scheduleCapacitorStatusBarSync();

    const root = document.documentElement;
    const observer = new MutationObserver(() => {
      void syncCapacitorStatusBarWithDocument().catch(() => {});
      void configureNativeStatusBar();
    });
    observer.observe(root, { attributes: true, attributeFilter: ['class'] });

    return () => observer.disconnect();
  }, []);

  return null;
}
